//
// System Overlay
//
// This blackens the screen and shows text to the user
// Use "show" to show and "hide" to hide

systemOverlay = {};
systemOverlay.width = 1920;
systemOverlay.height = 1080;

systemOverlay.show = function (text, closeButton) {
  closeButton = checkForUndefined(closeButton) ? false : closeButton;
  if (checkForUndefined(systemOverlay.homeURL)) {
    closeButton = false;
  }

  systemOverlay.textObject.text = text;
  systemOverlay.container.visible = true;
  Reflex.gamePaused = true;
  Reflex.singleRender = true;

  systemOverlay.button.visible = closeButton;

  systemOverlay.updateLayout();
};

systemOverlay.hide = function () {
  systemOverlay.container.visible = false;
  Reflex.gamePaused = false;
};

systemOverlay.resize = function (width, height) {
  if (!systemOverlay.container) {
    return;
  }

  systemOverlay.container.scale.set(
    width / systemOverlay.width,
    height / systemOverlay.height
  );
  systemOverlay.updateLayout();
};

systemOverlay.updateLayout = function () {
  if (typeof systemOverlay.graphics !== "undefined") {
    systemOverlay.textObject.x = systemOverlay.width / 2;
    systemOverlay.textObject.y = systemOverlay.height / 2;

    systemOverlay.graphics.position.x = systemOverlay.button.position.x =
      systemOverlay.width / 2;
    systemOverlay.graphics.position.y = systemOverlay.height / 2;
    systemOverlay.button.position.y = systemOverlay.height - 100;
    Reflex.singleRender = true;
  }
};

systemOverlay.createBox = function (
  graphics,
  width,
  height,
  colour,
  highlight,
  lowlight,
  borderWidth
) {
  var hw = width / 2;
  var hh = height / 2;
  graphics.beginFill(colour, 1);
  graphics.drawRect(-hw, -hh, width, height);
  graphics.endFill();
  graphics.lineStyle(borderWidth, highlight, 1);
  graphics.moveTo(-hw, hh);
  graphics.lineTo(-hw, -hh);
  graphics.lineTo(hw, -hh);
  graphics.lineStyle(3, lowlight, 1);
  graphics.moveTo(hw, -hh);
  graphics.lineTo(hw, hh);
  graphics.lineTo(-hw, hh);
};

systemOverlay.initialise = function (container) {
  systemOverlay.container = new PIXI.Container();
  container.addChild(systemOverlay.container);
  systemOverlay.container.visible = false;

  systemOverlay.graphics = new PIXI.Graphics();
  systemOverlay.graphics.alpha = 0.7;
  systemOverlay.container.addChild(systemOverlay.graphics);

  systemOverlay.button = new PIXI.Graphics();
  systemOverlay.container.addChild(systemOverlay.button);

  systemOverlay.graphics.beginFill(0x000000, 0.5);
  systemOverlay.graphics.drawRect(
    -systemOverlay.width / 2,
    -systemOverlay.height / 2,
    systemOverlay.width,
    systemOverlay.height
  );
  systemOverlay.graphics.endFill();
  systemOverlay.createBox(
    systemOverlay.graphics,
    systemOverlay.width - 100,
    systemOverlay.height - 150,
    0x0000aa,
    0x0000ff,
    0x000022,
    6
  );

  // Create button
  systemOverlay.createBox(
    systemOverlay.button,
    300,
    120,
    0xaaaaaa,
    0xffffff,
    0x555555,
    5
  );
  systemOverlay.button.interactive = true;
  systemOverlay.button.mousedown = systemOverlay.button.touchstart =
    systemOverlay.onButtonPressed;
  systemOverlay.buttonTextObject = new PIXI.Text(systemOverlay.text, {
    fontfamily: "Arial",
    fontWeight: "bold",
    fontSize: 40,
    fill: 0x000000,
    align: "center",
  });
  systemOverlay.buttonTextObject.anchor.set(0.5);
  systemOverlay.buttonTextObject.text = "CLOSE";
  systemOverlay.button.addChild(systemOverlay.buttonTextObject);

  systemOverlay.text = "";
  systemOverlay.textObject = new PIXI.Text(systemOverlay.text, {
    fontfamily: "Arial",
    fontSize: 40,
    fill: 0xffffff,
    strokeThickness: 6,
    align: "center",
  });
  systemOverlay.textObject.position.x = 0;
  systemOverlay.textObject.position.y = 0;
  systemOverlay.textObject.anchor.set(0.5);
  systemOverlay.container.addChild(systemOverlay.textObject);
};

systemOverlay.onButtonPressed = function () {
  if (checkForDefined(systemOverlay.homeURL)) {
    gdk.goHome();
  }
};

systemOverlay.onGameConfigEvent = function (gameConfigTask) {
  systemOverlay.homeURL = gameConfigTask.data.homeURL;
};

Reflex.registerEventHandler("resize", systemOverlay.resize);
messageBus.subscribe(
  "spinner:GameConfigEvent",
  systemOverlay.onGameConfigEvent
);
